import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 720,
    margin: '0 auto',
    padding: theme.spacing(4)
  },
  title: {
    marginBottom: theme.spacing(1)
  },
  subtitle: {
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary
  },
  card: {
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  paymentMethodRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 0),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  defaultBadge: {
    marginLeft: theme.spacing(2),
    color: theme.palette.success?.main || theme.palette.primary.main,
    fontWeight: 600
  },
  actions: {
    marginTop: theme.spacing(3),
    display: 'flex',
    gap: theme.spacing(2)
  },
  error: {
    marginTop: theme.spacing(2)
  }
}));

export default useStyles;
